const SOCIETY_CARD_CHOICE = "SOCIETY_CARD_CHOICE";

export const returnComponent = (choice) => { return { type: SOCIETY_CARD_CHOICE, choice } }

/**Change the component */
export const renderComponent = (choice) => (dispatch) => {
    dispatch(returnComponent(choice));
}

export const initialState = {
    choice: 'Card'
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SOCIETY_CARD_CHOICE:
            return { ...state, choice: action.choice };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/card-component-reducer.js